import { IconProps } from 'types/icon.type'

export const BagIcon = (props: IconProps) => {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Bag icon</title>
      <mask
        id="mask0_2_121"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="40"
        height="41"
      >
        <rect
          x="0.15979"
          y="0.326904"
          width="39.7258"
          height="39.7258"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_2_121)">
        <path
          d="M10.1977 35.9147C9.48626 35.9147 8.87685 35.661 8.36952 35.1537C7.86219 34.6464 7.60852 34.037 7.60852 33.3255V13.6753C7.60852 12.9638 7.86219 12.3544 8.36952 11.8471C8.87685 11.3397 9.48626 11.0861 10.1977 11.0861H14.0172V10.4707C14.0172 8.797 14.5997 7.37763 15.7647 6.21261C16.9297 5.04759 18.3491 4.46509 20.0228 4.46509C21.6966 4.46509 23.1159 5.04759 24.281 6.21261C25.446 7.37763 26.0285 8.797 26.0285 10.4707V11.0861H29.848C30.5594 11.0861 31.1688 11.3397 31.6762 11.8471C32.1835 12.3544 32.4372 12.9638 32.4372 13.6753V33.3255C32.4372 34.037 32.1835 34.6464 31.6762 35.1537C31.1688 35.661 30.5594 35.9147 29.848 35.9147H10.1977ZM10.1977 33.8349H29.848C29.9754 33.8349 30.0922 33.7819 30.1985 33.676C30.3044 33.5698 30.3574 33.453 30.3574 33.3255V13.6753C30.3574 13.5478 30.3044 13.431 30.1985 13.3248C30.0922 13.2188 29.9754 13.1659 29.848 13.1659H26.0285V17.0917C26.0285 17.3869 25.9285 17.6339 25.7285 17.8328C25.5285 18.032 25.2802 18.1316 24.9836 18.1316C24.687 18.1316 24.4404 18.032 24.2437 17.8328C24.047 17.6339 23.9487 17.3869 23.9487 17.0917V13.1659H16.097V17.0917C16.097 17.3869 15.997 17.6339 15.797 17.8328C15.597 18.032 15.3487 18.1316 15.0522 18.1316C14.7556 18.1316 14.509 18.032 14.3123 17.8328C14.1156 17.6339 14.0172 17.3869 14.0172 17.0917V13.1659H10.1977C10.0703 13.1659 9.95345 13.2188 9.84724 13.3248C9.7413 13.431 9.68833 13.5478 9.68833 13.6753V33.3255C9.68833 33.453 9.7413 33.5698 9.84724 33.676C9.95345 33.7819 10.0703 33.8349 10.1977 33.8349ZM16.097 11.0861H23.9487V10.4707C23.9487 9.36944 23.5698 8.43974 22.8119 7.68164C22.0538 6.92381 21.1241 6.5449 20.0228 6.5449C18.9216 6.5449 17.9919 6.92381 17.2338 7.68164C16.4759 8.43974 16.097 9.36944 16.097 10.4707V11.0861Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  )
}
